import APIService from "@/services/APIService";
import store from "@/store";
import { getMesskursInstructorAccessDebug, normalizeLicenseContacts } from "@/services/messkursAuth";

export async function resolveMesskursPermissions(user, course = null) {
    const contactsResponse = await APIService.getUserLicenseContacts().catch(() => []);
    const licenseContacts = normalizeLicenseContacts(contactsResponse);
    return getMesskursInstructorAccessDebug(user, licenseContacts, course);
}

export async function refreshMesskursPermissions(course = null) {
    const user = store.state.user;
    if (!user) return { hasAccess: false };

    const debug = await resolveMesskursPermissions(user, course);
    store.commit("updateUser", {
        ...user,
        messkursInstructorAccess: debug.hasAccess,
        messkursInstructorAccessDebug: debug,
    });

    return debug;
}
